import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

interface CianDraft {
  agent_fee: number;
  client_fee: number;
  deposit: number;
  floors_count: number;
  min_lease_term: number;
  office_id: number;
  prepay_months: number;
}

export function CianAPI(baseUrl: string) {
  return {
    getSession: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/cian/session/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<boolean>;
    },
    sendSms: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.post(
        `${baseUrl}/cian/sms/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<boolean>;
    },
    submitSms: async (code: string) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.put(
        `${baseUrl}/cian/sms/?business_profile_id=${businessProfileId}`,
        { code },
        true,
      )) as ApiResponse<boolean>;
    },
    createDraft: async (draft: CianDraft) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.post(
        `${baseUrl}/cian/draft/?business_profile_id=${businessProfileId}`,
        draft,
        true,
      )) as ApiResponse<boolean>;
    },
  };
}
